/* eslint-disable @typescript-eslint/ban-ts-comment */

/* eslint-disable react/prop-types */
import ErrorComponent from "web/Layout/Common/ErrorComponent";
import Loading from "web/Layout/Common/Loading";

import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";

import NavigationListContainerWithCategoryData from "./navigationListContainerWithCategoryData";
import useCategoryPaths from "./utils/useCategoryPaths";

const NavigationListContainer = () => {
  const { data, error, loading } = useCategoryPaths();

  switch (true) {
    case !!loading && (!data || !Object.keys(data).length): {
      return <Loading />;
    }
    case !!error: {
      newRelicErrorReport(
        error,
        "web-app/web/Layout/NavigationPanel/Navigation/List/navigationListContainer.tsx - 22"
      );
      return <ErrorComponent />;
    }
    default: {
      const paths = data?.msCategoryPaths || "";
      return <NavigationListContainerWithCategoryData paths={paths} />;
    }
  }
};

export default NavigationListContainer;
